export const suggestEditSubjects = (enable_sqft_suggest_an_edit: boolean) => [
    {
        label: 'Update the Property’s Name',
        value: 'Update the property’s name',
    },
    {
        label: 'Update the property’s address',
        value: 'Update the property’s address',
    },
    {
        label: 'Update the opening or closing date',
        value: 'Update the opening or closing date',
    },
    {
        label: 'Update the opening hours',
        value: 'Update the opening hours',
    },
    ...(enable_sqft_suggest_an_edit
        ? [
              {
                  label: 'Update Square Footage / Gross Leasable Area',
                  value: 'Update Square Footage / Gross Leasable Area',
              },
          ]
        : []),
    {
        label: 'Adjust the property’s boundaries',
        value: 'Adjust the property’s boundaries',
    },
];

export const suggestEditMarketSubjects = [
    {
        label: 'Update the name',
        value: 'Update the name',
    },
    {
        label: 'Update the category',
        value: 'Update the category',
    },
    {
        label: 'Adjust the boundaries',
        value: 'Adjust the boundaries',
    },
];
